import type { FC, ReactNode, KeyboardEventHandler } from 'react';
import React, { useCallback } from 'react';
import cn from 'classnames';
import { BackgroundV2 as Background } from '@alfa-bank/site-background-v2';
import type { TMarkdownComponents } from '@alfa-bank/site-markdown-container-v2/src/models/markdown-types';

import type { TCard } from './models';

export const Card: FC<TCard> = ({
    MarkdownContainer,
    Text,
    backgroundColor,
    isSelected,
    onClick,
    styles,
    subTitle,
    title,
    width,
}) => {
    const paragraph: TMarkdownComponents<'p'> = useCallback(
        ({ children }: { children: ReactNode }) => (
            <Text styler={{ margin: 0 }} view="primary-small">
                {children}
            </Text>
        ),
        [Text]
    );

    return (
        <div
            onClick={onClick}
            onKeyDown={onClick as unknown as KeyboardEventHandler}
            role="button"
            style={{ width }}
            tabIndex={0}
        >
            <Background
                className={cn(styles.card, styles.external, {
                    [styles.selected]: isSelected,
                })}
                color={backgroundColor}
                styler={{ borderRadius: 24, padding: 16 }}
            >
                {title && (
                    <Text styler={{ marginBottom: subTitle ? 8 : 0, marginTop: 0 }} view="xsmall">
                        {title}
                    </Text>
                )}
                {subTitle && (
                    <MarkdownContainer
                        content={subTitle}
                        renderers={{
                            p: paragraph,
                        }}
                    />
                )}
            </Background>
        </div>
    );
};
